import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=d5aa30b2"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports